import { route } from '../helpers';
import { PointStages } from '../../constants/AppConstants';
import SearchActions from '../../actions/SearchActions';

export default route(PointStages.SEARCH, {
    getComponent(location, cb) {
        require.ensure(
            [],
            require => {
                cb(null, require('../../components/point/Search').default);
            },
            'point-search',
        );
    },

    onEnter(nextState, replace, callback) {
        const { query } = nextState.location;

        if (query.origin || query.destination || query.outboundDateTime) {
            // Station lookup is async — use the RR3 callback form so the router
            // blocks rendering until PreviousSearchesStore is populated.
            SearchActions.preFillFromQuery(query)
                .then(() => callback())
                .catch(() => callback());
        } else {
            if (query.promoCode) {
                // pre fill and pre validate promo input on the main page if there's promoCode query param
                SearchActions.preFillPromoFromQuery(query);
            }
            callback();
        }
    },
});
